//Actions
import { SET_EXPORT_LOGS_LOADER, SET_EXPORT_LOGS_DATA, LOGOUT } from '../actions/action-types';

const initialState = {
  exportLogs: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalExportLogsInDB: null,
  loading: false,
  labels: [],
  applyFilters: false,
  filterSize: null,
  filters: {},
  returnAddresses: [],
};

const exportLogsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_EXPORT_LOGS_DATA:
      return {
        ...state,
        exportLogs: payload.rows,
        rowsCount: payload.count,
        totalExportLogsInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
      };
    case SET_EXPORT_LOGS_LOADER:
      return { ...state, loading: payload };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { exportLogsReducers };
